import { isAuthenticated } from '../guards/auth';

export default [
  {
    path: '/packages',
    name: 'packages',
    meta: { moduleId: 'packages' },
    component: () => import(/* webpackChunkName: "packages" */ '@/views/packages/Search.vue'),
    beforeEnter: isAuthenticated,
  },
];
